import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { getUserById } from '../utils/storage';
import '../styles/HistoryPage.css';

const HistoryPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = getUserById(userId);
    setUser(userData);
  }, [userId]);

  const handleViewReport = (date) => {
    // 这里可以根据日期加载对应的历史报告
    // 目前直接跳转到最新报告
    navigate(`/report/${userId}`);
  };

  if (!user) {
    return <div>加载中...</div>;
  }

  return (
    <div className="page history-page">
      <Header title="历史记录" showBack />

      <div className="history-container">
        <div className="student-info">
          <h2>{user.name}</h2>
          <p>{user.school}</p>
        </div>

        <div className="history-list">
          {user.reports && user.reports.map((report, index) => (
            <div
              key={index}
              className="history-item"
              onClick={() => handleViewReport(report.date)}
            >
              <span className="history-date">{report.date}筛查报告</span>
              <span className="history-arrow">›</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
